import Fab from "@material-ui/core/Fab";
import InputLabel from "@material-ui/core/InputLabel";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import HelpIcon from "@material-ui/icons/Help";
import React from "react";
import logo from "../../../_assets/kobo_logo/RakutenKobo_horizontal_knockout_RGB.png";
import locales from "../../../_constants/locales";
import "../styles/withLayout.css";

export default (WrappedComponent, MenuComponent = null) => {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                drawer_open: false
            };

            this.toggleDrawer = open => () => {
                this.setState({
                    drawer_open: open
                });
            };
        }

        componentWillMount() {
            if (!this.props.languageListLoading && this.props.languageList.length === 0) {
                this.props.getLanguageList();
            }

            if (!this.props.language) {
                this.props.setLanguage({ code: "EN", label: "English" });
            }
        }

        handleHelpClick() {
            window.open("https://help.kobo.com/", "_blank", "noreferrer");
        }

        handleLanguageChange(e) {
            this.props.setLanguage(this.props.languageList.filter(l => l.code === e.target.value)[0]);
        }

        render() {
            return (
                <div className="flex layout vertical">
                    <div style={{ height: "48px", width: "100%" }} className="layout vertical header-spacer"></div>
                    <header style={{ position: "fixed", top: 0, zIndex: 2, width: "100%" }} className="layout vertical">
                        <div className="flex layout horizontal">
                            <Paper
                                className="flex layout horizontal center"
                                elevation={3}
                                square={true}
                                style={{
                                    backgroundColor: "#bf0000",
                                    boxSizing: "border-box",
                                    height: "48px"
                                }}
                            >
                                <div className="flex">
                                    <img
                                        src={logo}
                                        alt="Rakuten Kobo"
                                        style={{
                                            height: "2rem",
                                            marginLeft: "0.618rem"
                                        }}
                                    />
                                </div>
                                <div className="language-selector-box layout horizontal">
                                    <form
                                        className="flex"
                                        autoComplete="off"
                                        onSubmit={e => {
                                            e.preventDefault();
                                        }}
                                    >
                                        <InputLabel htmlFor="language_select" style={{ display: "none" }}>
                                            Language
                                        </InputLabel>
                                        <Select
                                            native
                                            className="custom-select-language native"
                                            disabled={this.props.languageListLoading}
                                            value={(this.props.language && this.props.language.code) || ""}
                                            onChange={this.handleLanguageChange.bind(this)}
                                            inputProps={{ id: "language_select" }}
                                        >
                                            {this.props.languageList &&
                                                this.props.languageList.map((l, i) => {
                                                    return (
                                                        <option
                                                            key={i}
                                                            className="custom-select-language-item native"
                                                            value={l.code}
                                                            aria-selected={this.props.language && this.props.language.code === l.code}
                                                        >
                                                            {l.label}
                                                        </option>
                                                    );
                                                })}
                                        </Select>
                                    </form>
                                </div>
                            </Paper>
                        </div>
                    </header>
                    {this.props.ticketUpdating && (
                        <div className={`loading-box fit layout vertical center-center`} style={{ zIndex: 10 }}>
                            {/* <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} /> */}
                        </div>
                    )}
                    <main className="relative flex layout vertical center main scroll">
                        {this.props.languageList && this.props.languageList.length > 0 && this.props.language && this.props.language.code && (
                            <WrappedComponent {...this.props} />
                        )}
                    </main>
                    {this.props.languageList && this.props.languageList.length > 0 && this.props.language && this.props.language.code && (
                        <Fab
                            component="a"
                            variant="extended"
                            className="help-fab"
                            href="https://help.kobo.com/"
                            target="_blank"
                            aria-label={this.props.language ? locales[this.props.language.code].BUTTON.HELP.LABEL : "HELP"}
                        >
                            {this.props.language ? locales[this.props.language.code].BUTTON.HELP.LABEL : "HELP"}
                            <HelpIcon className="help-fab-icon" aria-hidden="true" />
                        </Fab>
                    )}
                </div>
            );
        }
    };
};
